import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { CreateFolderRequest, CreateFolderResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useCreateFolderMutation(options?: SimpleMutationOptions<CreateFolderResponse, CreateFolderRequest>) {
  return useBaseMutation({
    fnOption: {
      url: FolderUrl.createFolder,
    },
    ...options,
  });
}
